import { type FunctionComponent, type PropsWithChildren } from 'react'
import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, usePartnerId } from '@retailer-platform/dashboard/routing'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { widgetsRouter } from './routing/widgetsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { widgetsConfigViewAccessControl } from './access-control/widgetsAccess.configuration'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { enabledStoreConfigurationIds } from './constants'

// @ts-ignore
const NavItemWrapper: FunctionComponent<PropsWithChildren<{}>> = ({ children }) => {
  // On production, display the nav item only for the selected partners.
  const isProduction = clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'production'
  const enabledPartnerIds = Object.keys(enabledStoreConfigurationIds)
  const partnerId = usePartnerId()
  if (isProduction && !enabledPartnerIds.includes(partnerId)) return null

  return children
}

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'widgets',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'widgets-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [widgetsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Customize storefront UI components like the search bar, cart widget, authentication, and navigation menu',
          route: 'widgets-config',
          subRoutes: ['widgets-config-management'],
          accessControl: widgetsConfigViewAccessControl,
          labelId: 'widgetsDomain.title',
          position: 11,
          positionNavV2: 8,
          isNew: true,
          NavItemWrapper,
        },
      ],
    },
  ],
}

export default definition
